import React, { createContext, useContext, useState } from 'react';
import { client } from "../services/api";
const OrganizationContext = createContext();

export const useOrganization = () => {
  const context = useContext(OrganizationContext);
  if (!context) {
    throw new Error('useOrganization must be used within an OrganizationProvider');
  }
  return context;
};

export const OrganizationProvider = ({ children }) => {
  // Add your core state here
  const [organization, setOrganization] = useState(null);
  const [organizations, setOrganizations] = useState([]);
  const [organizationInvites, setOrganizationInvites] = useState([]);
  const [team, setTeam] = useState([]);
  const [teamInvites, setTeamInvites] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [accountSelected, setAccountSelected] = useState(null);
  const [getAccountsList, setGetAccountsList] = useState([]);

  const toggleOrganization = (org) => {
    setOrganization(org);
  };

  const toggleLoading = (loading) => {
    setLoading(loading);
  };

  const sendInvite = async (email, role, acctIdArray, type) => {
        let d = {
        email: email,
        role: role,
        accountId: acctIdArray,
        type: type
    }
    let invite = await client.sendInvite(d);
      };

  const fetchOrganizations = async () => {
    if(accountSelected) {
      let orgs = await client.getOrganizations(accountSelected);
      if(orgs.data) {
        setOrganizations(orgs.data);
      }
    } else {
      setOrganizations([]);
    }
  };

  const fetchOrganizationInvites = async () => {
    if(accountSelected) {
      let invites = await client.getOrganizationInvites(accountSelected);
      if(invites.data) {
        setOrganizationInvites(invites.data);
      }
    } else {
      setOrganizationInvites([]);
    }
  };

  const fetchTeam = async (id) => {
    let team = await client.getTeam(id);
        if(team.data) {
      setTeam(team.data.users);
    }
  };
  
  const fetchTeamInvites = async (id) => {
    let invites = await client.getTeamInvites(id);
        if(invites.data) {
      setTeamInvites(invites.data);
    }
  };

  const deleteOrganization = async (id) => {
    let orgs = await client.deleteOrg(id);
    return orgs;
  };

  const updateOrganization = async (data) => {
    let orgs = await client.updateOrgDetails(data);
    return orgs;
  };

  const getAccounts = async (accountId) => {
    let accounts = await client.getAccounts(accountId);

    setGetAccountsList([{"_id": "", "name": "Select an account"}, ...accounts.data]);
  };

  const setAccount = async (data) => {
    setAccountSelected(data);
  };

  const updateMarkup = async (accountId, markup) => {
    let res = await client.updateMarkup(accountId, markup);
    return res;
  };

  const createEmpGrp = async (data) => {
    let res = await client.createEmpGrp(data);
    return res;
  }
  

  const value = {
    // State
    organization,
    organizations,
    loading,
    error,
    team,
    teamInvites,
    organizationInvites,
    // Methods
    sendInvite,
    fetchOrganizations,
    fetchOrganizationInvites,
    fetchTeam,
    fetchTeamInvites,
    setOrganization,
    setLoading,
    setError,
    toggleOrganization,
    toggleLoading,
    setError,
    updateOrganization,
    deleteOrganization,
    getAccounts,
    accountSelected,
    setAccount,
    getAccountsList,
    updateMarkup,
    createEmpGrp,
  };

  return (
    <OrganizationContext.Provider value={value}>
      {children}
    </OrganizationContext.Provider>
  );
}; 